import { AutogenLayoutCarrierOfferAcceptPdfDialog } from "./autogen/AutogenLayoutCarrierOfferAcceptPdfDialog";

export class CarrierOfferAcceptPdfDialog extends AutogenLayoutCarrierOfferAcceptPdfDialog {


}
